import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/img/logo1.png';

class Logo extends Component {
    render() {
        return (
            <div style={{textAlign:'center', marginTop:'50px', marginBottom:'10px'}}>
                <Link to="">
                    <img className="super-admin-logo"  src={logo} alt=""/>
                </Link>                
            </div>
        );
    }
}

export default Logo;


// WEBPACK FOOTER //
// ./src/components/Auth/logo.jsx